import { render } from "./CrmRewardCard.vue?vue&type=template&id=e4b7095e&scoped=true"
import script from "./CrmRewardCard.vue?vue&type=script&lang=js"
export * from "./CrmRewardCard.vue?vue&type=script&lang=js"

import "./CrmRewardCard.vue?vue&type=style&index=0&id=e4b7095e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4b7095e"]])

export default __exports__